import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/park/blacklist/list/v2', Object.assign({}, options, {
    params
  }));

export const getDetail = (params, options) =>
  request.get('/api/park/blacklist/detail/v2', Object.assign({}, options, {
    params
  }));

export const remove = (params, options) =>
  request.post('/api/park/blacklist/remove/v2', qs.stringify(params), options);

export const add = (params, options) => request.post('/api/park/blacklist/submit/v2', params, options);

export const update = (params, options) =>
  request.post('/api/park/blacklist/submit/v2', params, options);

export const delayBlacklist = (params, options) =>
  request.post('/api/park/blacklist/delay/v2', params, options);

export const submitImportFile = (formData) => {
  return request({
    url: '/api/park/blacklist/import/v2',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: formData,
  });
};

export const syncBlacklist = (params, options) =>
  request.post('/api/park/blacklist/sync/v2', qs.stringify(params), options);

export const addBatch = (params, options) => request.post('/api/park/blacklist/addBatch/v2', params, options);
